var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.1136 19.1592L3.26359 13.3092C2.91214 12.9577 2.91214 12.3879 3.26359 12.0364L4.53636 10.7636C4.88781 10.4121 5.4577 10.4121 5.80915 10.7636L9.75 14.7044L18.1908 6.26359C18.5423 5.91214 19.1122 5.91214 19.4636 6.26359L20.7364 7.53639C21.0879 7.88785 21.0879 8.4577 20.7364 8.80919L10.3864 19.1592C10.0349 19.5107 9.46506 19.5107 9.1136 19.1592V19.1592Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.46af3cc1fa6c5ef084b0127ac6bbae57.svg";